import React, { useState } from 'react';

const itemsEmpleado = [
  { id: 'dashboard', icono: '🏠', label: 'Inicio' },
  { id: 'perfil', icono: '👤', label: 'Mi perfil' },
  { id: 'recibos', icono: '📄', label: 'Mis recibos' },
  { id: 'capacitaciones', icono: '📚', label: 'Capacitaciones' },
  { id: 'organigrama', icono: '🏢', label: 'Organigrama' },
  { id: 'mapa', icono: '🗺️', label: 'Mapa de obras' },
];

const itemsAdmin = [
  { id: 'admin-recibos', icono: '📤', label: 'Gestión recibos' },
  { id: 'capacitaciones', icono: '📥', label: 'Gestión capacitaciones' },
  { id: 'admin-empleados', icono: '👥', label: 'Gestión empleados' },
];

function Menu({ seccionActiva, onCambiarSeccion, perfil, onCerrarSesion }) {
  const [abierto, setAbierto] = useState(false);
  const esAdmin = perfil?.rol === 'admin' || perfil?.rol === 'rrhh';

  const handleClick = (id) => {
    onCambiarSeccion(id);
    setAbierto(false);
  };

  return (
    <>
      {/* TOPBAR */}
      <div className="topbar">
        <img src="/logo.png" alt="BellPro" className="topbar-logo" onClick={() => onCambiarSeccion('dashboard')} style={{cursor:'pointer'}} />
        <div className="topbar-right">
          <div className="topbar-usuario">
            <span className="topbar-nombre">{perfil?.nombre || 'Usuario'}</span>
            <span className="topbar-cargo">{perfil?.cargo || ''}</span>
          </div>
          <button className="hamburger-btn" onClick={() => setAbierto(!abierto)}>
            <span className={abierto ? 'linea abierta1' : 'linea'}></span>
            <span className={abierto ? 'linea abierta2' : 'linea'}></span>
            <span className={abierto ? 'linea abierta3' : 'linea'}></span>
          </button>
        </div>
      </div>

      {/* OVERLAY */}
      {abierto && <div className="menu-overlay" onClick={() => setAbierto(false)} />}

      {/* DRAWER */}
      <div className={`drawer ${abierto ? 'drawer-abierto' : ''}`}>
        <div className="drawer-header">
          <span>Portal BellPro</span>
        </div>

        <div className="drawer-seccion-label">Principal</div>
        {itemsEmpleado.map(item => (
          <div
            key={item.id}
            className={`drawer-item ${seccionActiva === item.id ? 'drawer-item-active' : ''}`}
            onClick={() => handleClick(item.id)}
          >
            <span className="drawer-ico">{item.icono}</span>
            <span>{item.label}</span>
          </div>
        ))}

        {esAdmin && (
          <>
            <div className="drawer-sep" />
            <div className="drawer-seccion-label">Administración</div>
            {itemsAdmin.map(item => (
              <div
                key={item.id}
                className={`drawer-item ${seccionActiva === item.id ? 'drawer-item-active' : ''}`}
                onClick={() => handleClick(item.id)}
              >
                <span className="drawer-ico">{item.icono}</span>
                <span>{item.label}</span>
              </div>
            ))}
          </>
        )}

        <div className="drawer-sep" />
        <div className="drawer-item drawer-cerrar" onClick={onCerrarSesion}>
          <span className="drawer-ico">🚪</span>
          <span>Cerrar sesión</span>
        </div>
      </div>
    </>
  );
}

export default Menu;